import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {i18n} from '../../../../translate/i18n'
import {Loading} from '../../../../components/Loading/Loading'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import {useNavigate} from 'react-router-dom'
import useModals from '../../../../hooks/useModals'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {Button} from '../../../../components/Button/Button'
import {Input} from '../../../../components/Input/Input'
import {Datatable} from '../../../../components/Datatable/Datatable'
import {DELETE, GET, POST, PUT} from '../../../../services/api'
import Swal from 'sweetalert2'

enum sectionType {
  category = 'category',
  content = 'content',
  simple = 'simple',
  form = 'form',
}

type SectionData = {
  id: number
  title: string
  type: sectionType
  itemId: number
  status: boolean
  created_at: string
  updated_at: string
}

const Content: FC = () => {
  const navigate = useNavigate()
  const {showDeleteModal} = useModals()
  const [sections, setSections] = useState<SectionData[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [idToDelete, setIdToDelete] = useState<number | null>(null)
  const [filterSection, setFilterSection] = useState<any>({
    select: 'Todos',
    label: 'Todos',
    value: 0,
  })

  const filterOptions = [
    {select: 'Todos', label: 'Todos', value: 0},
    {select: 'Categorias', label: 'Categorias', value: 'category'},
    {select: 'Conteúdos', label: 'Conteúdos', value: 'content'},
    {select: 'Simples', label: 'Simples', value: 'simple'},
    {select: 'Formulários', label: 'Formulários', value: 'form'},
  ]

  async function deleteSection() {
    if (!idToDelete) return

    const id = idToDelete

    try {
      await DELETE(`/hotel-post-pages/${id}`)
      setSections(sections.filter((section) => section.id !== id))

      Swal.fire({
        icon: 'success',
        title: String(i18n.t('hospitality_section.messages.delete.deleted_title')),
        text: String(i18n.t('hospitality_section.messages.delete.deleted_text')),
      })
    } catch (error) {
      console.error('Error deleting section', error)

      Swal.fire({
        title: String(i18n.t('hospitality_section.messages.delete.error_title')),
        text: String(i18n.t('hospitality_section.messages.delete.error_text')),
        icon: 'error',
      })
    }
  }

  async function fetchSections() {
    try {
      const result = await POST('/hotel-post-pages/filter', {
        type: filterSection.value !== 0 ? filterSection.value : undefined,
      })
      setSections(result.data)
    } catch (error) {
      console.error('Error fetching sections', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchSections()
  }, [])

  const switchStatus = async (Id: number, status: boolean) => {
    try {
      const newSections = [...sections]
      newSections.forEach((section) => {
        if (section.id === Id) section.status = !section.status
      })
      setSections(newSections)
      await PUT(`/hotel-post-pages/${Id}`, {
        status: !status,
      })
    } catch (e) {
      console.log(e)
    }
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <div className='row g-5 gx-xxl-12'>
      <div className='card card-xxl-stretch mb-5 mb-xl-12'>
        <div className='card-header py-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>
              {i18n.t('hospitality_section.index.page_title')}
            </span>
            <BreadCrumbs />
            <span className='text-muted mt-1 fw-bold fs-7'>
              {i18n.t('hospitality_section.index.page_subtitle')}
            </span>
          </h3>
          <div className='card-toolbar'>
            <Button
              text={i18n.t('hospitality_section.index.add_button')}
              color='primary'
              iconColor='#FFF'
              icon='fas fa-plus'
              size='small'
              horizontalPadding={6}
              btnAttr={{
                type: 'button',
              }}
              click={() => {
                navigate('/hospitality/content/section/criar')
              }}
              btnClass='mb-5 fw-bolder'
            />
          </div>
        </div>
        <div className='card-body'>
          <div className='d-flex align-items-center justify-content-start'>
            <div className='d-flex w-75 '>
              <div className=' align-items-end justify-content-start me-5 flex-grow-1'>
                <span className='align-self-start'>
                  {i18n.t('hospitality_section.index.filters.sections')}
                </span>
                <Input
                  inputAttr={{
                    type: 'select',
                  }}
                  options={filterOptions}
                  placeholder={i18n.t('hospitality_section.index.filters.sections')}
                  search={true}
                  value={filterSection}
                  change={(value: any) => setFilterSection(value)}
                />
              </div>
            </div>

            <div
              className='d-flex align-items-end w-100 justify-content-end h-100'
              style={{
                marginTop: '48px',
              }}
            >
              <Button
                text={i18n.t('buttons.filter')}
                color='primary'
                iconColor='#FFF'
                icon='fas fa-filter'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={fetchSections}
                btnClass='mb-0 fw-bolder'
              />
            </div>
          </div>
          <div>
            <Datatable
              data={sections}
              headers={[
                {
                  key: i18n.t('hospitality_section.index.table.headers.title'),
                  value: 'title',
                  type: 'default',
                },
                {
                  key: i18n.t('hospitality_section.index.table.headers.type'),
                  value: 'type',
                  type: 'default',
                },
                {
                  key: 'Status',
                  value: 'status',
                  type: 'check',
                  action: (item) => {
                    switchStatus(item.id, item.status)
                  },
                },
                {
                  key: i18n.t('hospitality_section.index.table.headers.actions'),
                  value: 'acoes',
                  type: '',
                },
              ]}
              options={[
                {
                  icon: 'fas fa-pen',
                  title: i18n.t('hospitality_section.index.actions.edit'),
                  action: (item: any) => {
                    navigate(`/hospitality/content/section/editar/${item.id}`)
                  },
                },
                {
                  icon: 'fas fa-trash',
                  action: (item: any) => {
                    setIdToDelete(item.id)
                    showDeleteModal(i18n.t('hospitality_section.index.actions.delete'))
                  },
                  path: '',
                  title: i18n.t('hospitality_section.index.actions.delete'),
                },
              ]}
              color='primary'
            />
          </div>
        </div>
      </div>
      <ModalDelete confirmAction={() => deleteSection()} />
    </div>
  )
}

const SectionConteudos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t('hospitality_section.index.page_title'),
            path: 'hospitality/feed/content',
            isActive: true,
          },
        ]}
      >
        {i18n.t('hospitality_section.index.page_title')}
      </PageTitle>
      <Content />
    </>
  )
}

export {SectionConteudos}
